import { gate } from 'hub-http/gates';

export const ReconnectButtonReconnectabilityGate = gate(
  'ReconnectButton::Reconnectability'
);
